import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=0be7aa15&scoped=true&"
import script from "./list2.vue?vue&type=script&lang=js&"
export * from "./list2.vue?vue&type=script&lang=js&"
import style0 from "./list2.vue?vue&type=style&index=0&id=0be7aa15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be7aa15",
  null
  
)

export default component.exports